<template>
    <form @submit.prevent="submit">
        <div class="modal-card" style="width: auto">
            
            <header class="modal-card-head">
                <p class="modal-card-title">Create Role</p>
            </header>
            
            <section class="modal-card-body">

                <b-field label="Role Name">
                    <b-input type="text" v-model="data.name" placeholder="Enter Role Name"></b-input>
                </b-field>
                
                <!-- <b-field label="Role Type">
                    <b-input type="text" v-model="data.type" placeholder="Enter Role Type"></b-input>
                </b-field> -->
            
            </section>
            
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>

                <button class="button is-primary" :disabled="loading">Create</button>
            </footer>
        
        </div>
    </form>
</template>
<script>
import { RoleService } from "@/services/role.service";

export default {
    props: {
        isCreateRole: {
            type: Boolean,
            default: () => false
        }
    },
    data: () => ({
        roleService: RoleService,
        data: { name: null, type: null },
        loading: false
    }),
    methods: {
        async submit() {
            try {
                this.loading = true;
                const role = await this.roleService.create(this.data);
                this.loading = false;
                this.$emit("created");
                this.$parent.close();
            } catch (err) {
                this.loading = false;
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Roles/partials/createRoleModal.vue